import { useQuery } from '@apollo/client';
import type { UseDirectDealsDetailsFetchResponse } from '@openx/components-direct-deals/lib/utils/context/types.ts';
import type { DirectDealsItemDetails } from '@openx/types/directDeals.ts';
import { GetPublisherProfileDetailsDocument } from '../../../graphql/query/directDeals/GetPublisherProfileDetails.generated.tsx';

export const useDirectDealsDetailsFetch = (publisherId = ''): UseDirectDealsDetailsFetchResponse => {
  const {
    data: { publisherProfileByPk } = {},
    loading,
    error,
  } = useQuery(GetPublisherProfileDetailsDocument, {
    variables: {
      id: publisherId,
    },
    skip: !publisherId,
  });

  const mappedProfiles: DirectDealsItemDetails = {
    ...publisherProfileByPk?.obj,
    audience_distribution_female: Number(publisherProfileByPk?.obj?.audience_distribution_female),
    audience_distribution_male: Number(publisherProfileByPk?.obj?.audience_distribution_male),
    audience_distribution_other: Number(publisherProfileByPk?.obj?.audience_distribution_other),
    cpm_low: Number(publisherProfileByPk?.obj?.cpm_low),
    cpm_high: Number(publisherProfileByPk?.obj?.cpm_high),
    geo_region: publisherProfileByPk?.obj?.geo_region,
    mln_impressions: Number(publisherProfileByPk?.obj?.mln_impressions),
    mln_unique_visitors: Number(publisherProfileByPk?.obj?.mln_unique_visitors),
    top_countries: publisherProfileByPk?.obj?.top_countries,
  };

  return {
    data: mappedProfiles,
    loading,
    error,
  };
};
